/* eslint-disable import/prefer-default-export */
import { CompanyCategories, Request } from '@centecomm/portal-service';
import { LoadStatus } from '../../Types';
import { RequestState } from './Types';
import { RequestActionTypes, RequestActions } from './actions';

const initialState: RequestState = {
    categories: {
        loadStatus: LoadStatus.INITIAL_STATE,
    },
    requestHistory: {},
    requestNotes: {},
    requests: {
        loadStatus: LoadStatus.INITIAL_STATE,
    },
    pendingAttachments: {},
    requestAutoComplete: {},
    requestFilters: {
        categories: {
            loadStatus: LoadStatus.INITIAL_STATE,
        },
        priorities: {
            loadStatus: LoadStatus.INITIAL_STATE,
        },
    },
};

// eslint-disable-next-line import/prefer-default-export
export function requestsReducer(state: RequestState = initialState, action: RequestActionTypes): RequestState {
    switch (action.type) {
        case RequestActions.LOAD_REQUESTS:
            return {
                ...state,
                requests: {
                    loadStatus: LoadStatus.PENDING,
                },
            };
        case RequestActions.SET_REQUESTS:
            return {
                ...state,
                requests: {
                    loadStatus: LoadStatus.LOADED,
                    ...action.payload.reduce(
                        (agg, curr: Request) => ({
                            ...agg,
                            [`${curr.id}`]: curr,
                        }),
                        {},
                    ),
                },
            };
        case RequestActions.ADD_REQUEST:
            return {
                ...state,
                requests: {
                    ...state.requests,
                    [action.payload.id]: action.payload,
                },
            };
        case RequestActions.LOAD_CATEGORIES:
            return {
                ...state,
                categories: {
                    loadStatus: LoadStatus.PENDING,
                },
            };
        case RequestActions.SET_CATEGORIES:
            return {
                ...state,
                categories: {
                    loadStatus: LoadStatus.LOADED,
                    ...action.payload.reduce(
                        (agg, curr: CompanyCategories) => ({
                            ...agg,
                            [`${curr.companyId}`]: curr,
                        }),
                        {},
                    ),
                },
            };
        case RequestActions.UPDATE_CATEGORY:
            return {
                ...state,
                requests: {
                    ...state.requests,
                    [action.payload.id]: {
                        ...state.requests[action.payload.id],
                        category: action.payload.category,
                    },
                },
            };
        case RequestActions.UPDATE_SUBCATEGORY:
            return {
                ...state,
                requests: {
                    ...state.requests,
                    [action.payload.id]: {
                        ...state.requests[action.payload.id],
                        subCategory: action.payload.subcategory,
                    },
                },
            };
        case RequestActions.UPDATE_STATUS:
            return {
                ...state,
                requests: {
                    ...state.requests,
                    [action.payload.id]: {
                        ...state.requests[action.payload.id],
                        status: action.payload.status,
                    },
                },
            };
        case RequestActions.UPDATE_PRIORITY:
            return {
                ...state,
                requests: {
                    ...state.requests,
                    [action.payload.id]: {
                        ...state.requests[action.payload.id],
                        priority: action.payload.priority,
                    },
                },
            };
        case RequestActions.ASSIGN_USER:
            return {
                ...state,
                requests: {
                    ...state.requests,
                    [action.payload.id]: {
                        ...state.requests[action.payload.id],
                        assignedTo: action.payload.user,
                    },
                },
            };
        case RequestActions.SET_HISTORY:
            return {
                ...state,
                requestHistory: {
                    ...state.requestHistory,
                    [action.payload.id]: action.payload.history,
                },
            };
        case RequestActions.SET_NOTES:
            return {
                ...state,
                requestNotes: {
                    ...state.requestNotes,
                    [action.payload.id]: action.payload.notes,
                },
            };
        case RequestActions.ADD_NOTE:
            return {
                ...state,
                requestNotes: {
                    ...state.requestNotes,
                    [action.payload.id]: [...state.requestNotes[action.payload.id], action.payload.note],
                },
            };
        case RequestActions.ADD_PENDING_ATTACHMENTS:
            return {
                ...state,
                pendingAttachments: {
                    ...state.pendingAttachments,
                    [action.payload.id]: action.payload.files,
                },
            };
        case RequestActions.CLEAR_PENDING_ATTACHMENTS:
            // eslint-disable-next-line no-case-declarations
            const { [action.payload]: cpaClearing, ...cpaRest } = state.pendingAttachments;

            return {
                ...state,
                pendingAttachments: {
                    ...cpaRest,
                },
            };
        case RequestActions.SET_AUTOCOMPLETE_DATA:
            return {
                ...state,
                requestAutoComplete: action.payload,
            };
        case RequestActions.LOAD_CATEGORY_FILTERS:
            return {
                ...state,
                requestFilters: {
                    ...state.requestFilters,
                    categories: {
                        loadStatus: LoadStatus.PENDING,
                    },
                },
            };
        case RequestActions.SET_CATEGORY_FILTERS:
            return {
                ...state,
                requestFilters: {
                    ...state.requestFilters,
                    categories: {
                        loadStatus: LoadStatus.LOADED,
                        ...action.payload.reduce(
                            (agg, curr: CompanyCategories) => ({
                                ...agg,
                                [`${curr.companyId}`]: curr,
                            }),
                            {},
                        ),
                    },
                },
            };
        case RequestActions.SET_CATEGORY_FILTERS_ERROR:
            return {
                ...state,
                requestFilters: {
                    ...state.requestFilters,
                    categories: {
                        loadStatus: LoadStatus.ERROR,
                        errorState: {
                            error: action.payload.errorMessage,
                            secondaryMessage: action.payload.secondaryMessage,
                        },
                    },
                },
            };
        case RequestActions.LOAD_PRIORITY_FILTERS:
            return {
                ...state,
                requestFilters: {
                    ...state.requestFilters,
                    priorities: {
                        loadStatus: LoadStatus.PENDING,
                    },
                },
            };
        case RequestActions.SET_PRIORITY_FILTERS:
            return {
                ...state,
                requestFilters: {
                    ...state.requestFilters,
                    priorities: {
                        loadStatus: LoadStatus.LOADED,
                        ...action.payload.priorities,
                    },
                },
            };
        case RequestActions.SET_PRIORITY_FILTERS_ERROR:
            return {
                ...state,
                requestFilters: {
                    ...state.requestFilters,
                    priorities: {
                        loadStatus: LoadStatus.ERROR,
                        errorState: {
                            error: action.payload.errorMessage,
                            secondaryMessage: action.payload.secondaryMessage,
                        },
                    },
                },
            };
        default:
            return state;
    }
}
